export default __webpack_public_path__ + "static/media/company_about.83e94bf3.jpg";